export type DocoonEventTypeConfig = {
    labelKey: string;
    iconPath: string;
};

/**
 * Maps Docoon event type strings → i18n key + SVG icon path.
 * Only intermediate events (not sign / refus) belong here.
 * Any type not listed is silently ignored in the timeline.
 * To support a new type: add one entry here + the matching key in fr.json / en.json.
 */
export const DOCOON_EVENT_TYPES: Record<string, DocoonEventTypeConfig> = {
    Mail: {
        labelKey: "DocoonTracking.EventMail",
        iconPath: "M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 4-8 5-8-5V6l8 5 8-5z",
    },
    "Mail:security code": {
        labelKey: "DocoonTracking.EventSecurityCode",
        iconPath:
            "M12 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm6-9h-1V6A5 5 0 0 0 7 6v2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2zM8.9 6a3.1 3.1 0 0 1 6.2 0v2H8.9z",
    },
    "SMS:security code": {
        labelKey: "DocoonTracking.EventSmsSecurityCode",
        iconPath: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z",
    },
};

/** Crealo-generated event type emitted right after a successful send to Docoon. */
export const CREALO_SIGNATORY_SENT = "signatorySent";

/** Crealo-generated event type when Docoon reports a signatory as signed. */
export const CREALO_SIGNATORY_SIGNED = "signatorySigned";

/** Crealo-generated event type when Docoon reports a signatory as refused. */
export const CREALO_SIGNATORY_REFUSED = "signatoryRefused";

/** Crealo-generated event type when Docoon reports a signatory as canceled. */
export const CREALO_SIGNATORY_CANCELED = "signatoryCanceled";

/** Crealo-generated event type when the full contract is signed. */
export const CREALO_CONTRACT_SIGNED = "contractSigned";

/** Crealo-generated event type when the contract is refused. */
export const CREALO_CONTRACT_REFUSED = "contractRefused";
